import {
  BreadcrumbItem,
  BreadcrumbLink,
  Breadcrumbs,
} from '@cxc/react-fds-components'
import { Link } from 'react-router-dom'

type BreadcrumbsProps = {
  links: { label: string; url: string; active: boolean }[]
}

function BreadcrumbLinks({ links }: BreadcrumbsProps) {
  return (
    <Breadcrumbs>
      {links.map((link) => (
        <BreadcrumbItem key={link.label}>
          <BreadcrumbLink as={Link} to={link.url} active={link.active}>
            {link.label}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumbs>
  )
}

export default BreadcrumbLinks
